import styled from 'styled-components';

export const Container = styled.div<{ $animationTimeout: number }>`
  border-radius: ${({ theme }) => theme.misc.tileBRadius};
  background-color: ${({ theme }) => theme.baseBlue.a10};
  box-shadow: 0 10px 40px 0 rgba(78, 84, 107, 0.4);
  display: flex;
  padding: 15px;
  color: ${({ theme }) => theme.white.a10};
  font-size: 1rem;
  opacity: 0;
  margin-bottom: -20px;
  transition: all ${({ $animationTimeout }) => $animationTimeout}ms;

  &.enter-active,
  &.enter-done {
    margin-bottom: 15px;
    opacity: 1;
  }

  &.top {
    margin-bottom: 0;
    margin-top: -20px;

    &.enter-active,
    &.enter-done {
      margin-top: 15px;
      opacity: 1;
    }
  }

  .icon-box {
    margin-right: 15px;
  }

  .txt {
    max-width: 75vw;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    line-height: 1.5rem;
  }

  .close-btn {
    padding: 0;
    background: transparent;
    border: 0;
    margin-left: 15px;
    outline: none;
    cursor: pointer;
    opacity: 0.7;
    &:hover {
      opacity: 1;
    }
  }
`;
